import React from 'react';
import Link from 'gatsby-link';

import styled from 'styled-components';
import _ from 'lodash';
import { COLORS } from '../config';

// Utils
import { createSlugFromTitle } from '../utils';

// Components
import Leaderboard from '../components/Leaderboard';
import Card from '../components/Card';
import ResearchCard from '../components/ResearchCard';
import { FlaskIcon, PodiumIcon } from '../components/AnimatedIcons';

import { media } from '../styles/style-utils';

const PageWrapper = styled.section``;

const LeaderboardsWrapper = styled.section`
  width: 100%;
  text-align: center;

  > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 0 2rem;
  }
`;

const ResearchWrapper = styled.section`
  margin: 0 0 4rem 0;
  text-align: center;

  > svg {
    margin: 0 auto;
  }
`;

const ResearchCards = styled.div`
  display: grid;
  grid-template-columns: 100%;
  ${media.fromLarge`grid-template-columns: 50% 50%;`}
  grid-auto-rows: 1fr;
`;

const NutrientsWrapper = styled.section`
  padding: 2rem 0 0;
`;

const CenteredHeading = styled.hgroup`
  text-align: center;
  margin: 3rem 0 2rem;

  > h1 {
    width: 100%;
    text-align: center;
  }
`;

const NutrientsList = styled.ul`
  vertical-align: top;
  margin: 0 0 4rem;
  > li {
    width: 100px;
    margin: 0 10px 50px 10px;
    padding: 10px;
    list-style-type: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    > a {
      display: block;
      padding: 1rem;
      border: 1px solid black;
    }
  }
`;

const IndexPage = ({ data }) => {

  const liveFoods = _.filter(
    _.sortBy(data.allGoogleSheetFoodsRow.edges, ({ node }) => node.title),
    ({ node }) => node.live
  );

  // create colors by key
  const foodContent = _.keyBy(liveFoods.map(({ node }) => node), 'title');

  const allLeaderboardItems = data.allGoogleSheetLeaderboardsRow.edges.map(({ node }) => node.items.split(','));

  const missing = _.filter(_.uniq(_.flatten(allLeaderboardItems)), item => !_.find(foodContent, c => c.title === item));
  console.warn('Missing foods', missing);

  const filteredNodes = _.sortBy(
    data.allMarkdownRemark.edges
    .filter(({ node }) => node.frontmatter.type === 'nutrient')
    .map(({ node }) => node)
  , node => node.frontmatter.name);

  return (
    <PageWrapper>
      <ResearchWrapper>
        <CenteredHeading>
          <h1>Medical Research</h1>
          <p>Find out exactly how different foods can improve your health. Backed up by evidence.</p>
        </CenteredHeading>
        <ResearchCards>
          {_.filter(data.allGoogleSheetResearchRow.edges, e => e.node.featured).map(edge => {
            const researchNode = edge.node;
            return (
              <ResearchCard
                key={researchNode.id}
                {...researchNode}
                content={foodContent[researchNode.title]} />
            );
          })}
        </ResearchCards>
      </ResearchWrapper>

      <LeaderboardsWrapper>
        <PodiumIcon
          width={80}
          height={80}
          colors={[COLORS[1]]}
          nodeColors={[COLORS[0], COLORS[0], COLORS[0]]} />
          <CenteredHeading>
            <h1>Food Lists</h1>
          </CenteredHeading>
        <div>
        {data.allGoogleSheetLeaderboardsRow.edges.map(edge => {
          const { description, title, image, items } = edge.node;
          const fullItems = items.split(',').map(item => {
            const match = _.find(liveFoods.edges, edge => {
              return edge.node.title === item;
            });
            return match
              ? match.node
              : { title: item };
          });
          return <Leaderboard split={true} key={edge.node.id} image={image} title={title} description={description} items={fullItems}></Leaderboard>
        })}
        </div>
      </LeaderboardsWrapper>
      <NutrientsWrapper>
        <CenteredHeading><h1>Vitamins & Nutrients</h1></CenteredHeading>
        <NutrientsList>
          {filteredNodes.map(node => <li key={node.frontmatter.name}><Link to={node.frontmatter.path}>{node.frontmatter.name}</Link></li>)}
        </NutrientsList>
      </NutrientsWrapper>
    </PageWrapper>
  );
};

export const query = graphql`
  query ItemsQuery {
    allGoogleSheetFoodsRow {
      edges {
        node {
          id
          title
          live
          ndbno
          description
          sourcing
          themecolor
          textcolor
          bestknownfor
          toomuchcauses
          tags
          serving
          servingtext
          verb
        }
      }
    }
    allGoogleSheetDietsRow {
      edges {
        node {
          id
          name
          description
          good
          bad
        }
      }
    }
    allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            path
            name
            altname
            tags
            type
          }
        }
      }
    }
    allGoogleSheetLeaderboardsRow {
      edges {
        node {
          id
          title
          description
          items
        }
      }
    }
    allGoogleSheetResearchRow {
      edges {
        node {
          id
          title
          featured
          heading
          prevents
          reliability
          link1
          link2
          link3
        }
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js